import { Component, OnInit } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { AdminService } from '../../services/admin.service';
import { CommonService } from '../../../core/common/services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { TestTypeDTO } from '../../model/test-type.entity';
import { ActivatedRoute, Router } from '@angular/router';
import { Utility } from '../../../core/common/services/utility.service';


@Component({
  selector: 'tandc-test-type-standard',
  templateUrl: './test-type-standard.component.html',
})
export class TestTypeStandardComponent implements OnInit {

  standardList: Dropdown[] = [];
  glassBehaviourList: Dropdown[] = [];
  model: TestTypeDTO = new TestTypeDTO();
  showModal: boolean = false;
  testType: TestTypeDTO = new TestTypeDTO();

  constructor(
    private service: AdminService,
    private commonService: CommonService,
    private translate: TranslateService,
    private utility: Utility,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // this.getAll();
    const id = this.route.snapshot.paramMap.get('id');
    if (id && Number(id) > 0) {
      this.service.getTestTypeById(Number(id)).subscribe((x) => {
        this.model = x.value;
        this.getAll();
      });
    } else {
      this.getAll();
    }
  }

  getAll() {
    this.service.getStandard().subscribe((x) => {

      this.standardList = Utility.reorderSelectedOnTop(
        x.value,
        this.model.standard
      );
    });
    this.service.getGlassBehaviour().subscribe((x) => {
      this.glassBehaviourList = Utility.reorderSelectedOnTop(
        x.value,
        this.model.glassBehaviour
      );
    });
  }

  save(data: TestTypeDTO) {
    const onSuccess = (res: any) => {
      if (res) {
        this.showModal = !this.showModal;
        const msg =
          data.id > 0
            ? 'Alerts.UpdatedSuccessfully'
            : 'Alerts.SavedSuccessfully';
        this.commonService.successMessage(this.translate.instant(msg));
        this.router.navigate(['admin/testType']);

        this.standardList = Utility.reorderSelectedOnTop(
          this.standardList,
          data.standard
        );
        this.glassBehaviourList = Utility.reorderSelectedOnTop(
          this.glassBehaviourList,
          data.glassBehaviour
        );
      }
    };

    if (data.id > 0) {
      this.service.updateTstType(data).subscribe(onSuccess);
    } else {
      this.service.saveTstType(data).subscribe(onSuccess);
    }
  }


  cancel() {
    this.router.navigate(['admin/testType']);
  }

  selectedStandards(value: any) {
    const std = this.standardList.find((item) => item.id === value);
    return std?.name;
  }

  deleteStandard(standard: any) {
    this.model.standard = this.model.standard.filter((x) => x !== standard);
  }

  selectedGlassBehaviour(value: any) {
    const gb = this.glassBehaviourList.find((item) => item.id === value);
    return gb?.name;
  }

  deleteGlassBehaviour(behaviour: any) {
    this.model.glassBehaviour = this.model.glassBehaviour.filter(
      (x) => x !== behaviour
    );
  }

}
